"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "drawer-container"
  }, [_c("div", [_c("h3", {
    staticClass: "drawer-title"
  }, [_vm._v("系统布局设置")]), _vm._v(" "), _c("div", {
    staticClass: "drawer-item"
  }, [_c("span", [_vm._v("主题颜色")]), _vm._v(" "), _c("theme-picker", {
    staticStyle: {
      float: "right",
      height: "26px",
      margin: "-3px 8px 0 0"
    },
    on: {
      change: _vm.themeChange
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "drawer-item"
  }, [_c("span", [_vm._v("显示标签")]), _vm._v(" "), _c("el-switch", {
    staticClass: "drawer-switch",
    model: {
      value: _vm.tagsView,
      callback: function callback($$v) {
        _vm.tagsView = $$v;
      },
      expression: "tagsView"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "drawer-item"
  }, [_c("span", [_vm._v("固定头部")]), _vm._v(" "), _c("el-switch", {
    staticClass: "drawer-switch",
    model: {
      value: _vm.fixedHeader,
      callback: function callback($$v) {
        _vm.fixedHeader = $$v;
      },
      expression: "fixedHeader"
    }
  })], 1), _vm._v(" "), _c("div", {
    staticClass: "drawer-item"
  }, [_c("span", [_vm._v("显示LOGO")]), _vm._v(" "), _c("el-switch", {
    staticClass: "drawer-switch",
    model: {
      value: _vm.sidebarLogo,
      callback: function callback($$v) {
        _vm.sidebarLogo = $$v;
      },
      expression: "sidebarLogo"
    }
  })], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;